import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";
import ArrowLeftIcon from "@dcl/icons/esm/ui/arrow-left";
var CLASS_NAME = "SiteHeaderPanel";
var ANIMATION_CLOSED = "".concat(CLASS_NAME, "-closed");

var Panel = function Panel(_ref) {
  var children = _ref.children,
      onBack = _ref.onBack,
      open = _ref.open,
      title = _ref.title;
  var getClassName = getClassNameFactory(CLASS_NAME);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isClosed = _useState2[0],
      setClosedState = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      prevOpenState = _useState4[0],
      setPrevOpenState = _useState4[1];

  var backButtonRef = useRef(null);
  var panelRef = useRef(null); // Focus back button when panel opens

  useEffect(function () {
    if (open && backButtonRef.current) {
      backButtonRef.current.focus();
    }
  }, [open]); // same as `deriveComponentStateFromProps`

  if (prevOpenState !== open) {
    setPrevOpenState(open);
    /**
     * set `isClosed = true` when the panel is not open and isClosed is false
     */

    if (!open && !isClosed) {
      setClosedState(true);
    }
  }

  useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      if (!open || e.key !== "Tab") {
        return;
      } // Only apply circular tabbing on mobile (below 75em/1200px)


      var isMobile = window.innerWidth < 1200;

      if (!isMobile) {
        return;
      } // Use the ref instead of querySelector


      var panelElement = panelRef.current;

      if (!panelElement) {
        return;
      }

      var focusableElements = panelElement.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])');

      if (!focusableElements || focusableElements.length === 0) {
        return;
      }

      var focusableArray = Array.from(focusableElements);
      var currentIndex = focusableArray.indexOf(document.activeElement);

      if (currentIndex === -1) {
        return;
      } // Shift + Tab - circle to last element


      if (currentIndex === 0 && e.shiftKey) {
        e.preventDefault();
        focusableArray[focusableArray.length - 1].focus();
        return;
      } // Tab - circle to first element


      if (!e.shiftKey && currentIndex === focusableArray.length - 1) {
        e.preventDefault();
        focusableArray[0].focus();
      }
    };

    if (open) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);
  return /*#__PURE__*/React.createElement("div", {
    ref: panelRef,
    className: getClassName({
      states: classNames({
        animating: true,
        // animating needs to be true for keyframes to take effect
        closed: isClosed,
        open: open
      })
    }),
    onAnimationEnd: function onAnimationEnd(e) {
      /**
       * we need to set the close state to false to remove the class name
       * otherwise it will re-animate the closed state when open state changes again
       */
      if (e.animationName === ANIMATION_CLOSED) {
        setClosedState(false);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "bar"
    })
  }, /*#__PURE__*/React.createElement("button", {
    className: getClassName({
      descendantName: "backButton"
    }),
    onClick: onBack,
    "aria-label": "Back",
    ref: backButtonRef
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "false"
  }, /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    width: 16
  }))), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "barTitle"
    })
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "inner"
    })
  }, children));
};

export default Panel;